import React, { Fragment, memo, useCallback } from 'react'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import {
  GridColumnMenuHideItem,
  GridColumnMenuItemProps,
  useGridApiContext,
  useGridRootProps,
} from '@mui/x-data-grid-pro'

const GridColumnMenuColumnsItemWithHeaderTriggerComponent = ({
  colDef,
  onClick,
}: GridColumnMenuItemProps) => {
  const apiRef = useGridApiContext()
  const rootProps = useGridRootProps()

  const handleManageColumnsClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      onClick(event)
      document.getElementById('grid-columns-select-button')?.click()
    },
    [onClick],
  )

  return (
    <Fragment>
      <GridColumnMenuHideItem colDef={colDef} onClick={onClick} />
      <MenuItem onClick={handleManageColumnsClick}>
        <ListItemIcon>
          <rootProps.slots.columnMenuManageColumnsIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{apiRef.current.getLocaleText('columnMenuManageColumns')}</ListItemText>
      </MenuItem>
    </Fragment>
  )
}

export const GridColumnMenuColumnsItemWithHeaderTrigger = memo(
  GridColumnMenuColumnsItemWithHeaderTriggerComponent,
)
